// src/components/Admin/Sidebar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  FileText,
  FolderKanban,
  UserCog,
  Mail, 
  MessageCircle 
} from "lucide-react";
import logoImg from "../assets/devdeepam_logo.png";

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { name: "Dashboard", icon: LayoutDashboard, path: "/admin" },
    // { name: "Leads", icon: Users, path: "/admin/leads" },
    { name: "Enquiries", icon: Mail, path: "/admin/enquiries" },
    { name: "Quotations", icon: FileText, path: "/admin/quotations" },
    { name: "Projects", icon: FolderKanban, path: "/admin/projects" },
    { name: "Employees", icon: UserCog, path: "/admin/employees" },
    { name: "Testimonials", icon: MessageCircle, path: "/admin/testimonials" },
  ];

  return (
    <div className="w-64 bg-white dark:bg-slate-900 text-slate-800 dark:text-white border-r border-slate-200 dark:border-slate-800 flex flex-col h-screen transition-colors duration-200">
      <div className="p-4 border-b border-slate-200 dark:border-slate-800 flex items-center gap-3">
        {/* Logo Container */}
        <div className="flex items-center gap-2.5">
          <img
            src={logoImg}
            alt="DevDeepam Logo"
            className="h-11 w-auto object-contain"
          />
          <div className="flex flex-col justify-center">
            <span className="text-sm font-black tracking-widest text-slate-900 dark:text-white uppercase leading-none">
              Devdeepam
            </span>
            <span className="text-[9px] text-slate-400 dark:text-slate-500 mt-1 font-bold uppercase tracking-widest">
              Renewable Portal
            </span>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-1.5 overflow-y-auto">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.name}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${
                isActive
                  ? "bg-emerald-500/10 text-[#10B981] dark:bg-emerald-500/15 dark:text-emerald-400 border border-emerald-500/20"
                  : "text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white"
              }`}
            >
              <item.icon size={19} />
              <span>{item.name}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;